/* eslint-disable consistent-return */
// eslint-disable-next-line no-prototype-builtins
const isDatePropertyExist = (objA, objB) => objA.hasOwnProperty('date') && objB.hasOwnProperty('date');

export const sortDateAscending = (a, b) => {
  if (!isDatePropertyExist(a, b)) {
    return;
  }
  const aDate = new Date(a.date).getTime();
  const bDate = new Date(b.date).getTime();

  if (aDate > bDate) {
    return 1;
  }
  if (aDate < bDate) {
    return -1;
  }

  return 0;
};

export const sortDateDescending = (a, b) => {
  if (!isDatePropertyExist(a, b)) {
    return;
  }
  const aDate = new Date(a.date).getTime();
  const bDate = new Date(b.date).getTime();

  if (bDate > aDate) {
    return 1;
  }
  if (bDate < aDate) {
    return -1;
  }

  return 0;
};
